<template>
  <div class="col col_1_of_3">  
    <!-- TO DO customer gift -->  
    <div class="weAcceptRight"><img src="https://translationpal.com/imgs/2015/credit_cards.png" alt="" style="width:477px;height:156px;"></div>
    <!--Begin Comm100 Live Chat Code-->
    <div id="comm100-button-2593"  class="weAcceptRight"></div>
    <!--End Comm100 Live Chat Code-->
    <div class="secureRight"><img src="https://translationpal.com/imgs/2015/two-professional-proofreaders.png" alt="" style="width:320px;height:128px;"></div>
    
    <div class="rightTestimonial rightTestimonialHidden" id="mlaTestimonial">
        <p>"Super helpful! My certificate was translated into English accurately and delivered back on time."</p>
        <span class="author">Tyler Kerr</span>
    </div>

    <div class="weAcceptRight">
        <img src="https://translationpal.com/imgs/2015/guarantee-100.png" alt="" style="width:87px;height:87px;">
    </div>

    <div class="rightRewiews">
        <div class="reviewsHeading">
            <div class="review_container">
                <h2 class="review_title">Recent Google Reviews</h2>
                <!--<div class="review_stars_row">
                    <span class="review_star full">★</span>
                    <span class="review_star full">★</span>
                    <span class="review_star full">★</span>
                    <span class="review_star full">★</span>
                    <span class="review_star">★</span>
                </div>
                <p class="review_rating"><strong>4.8</strong> rating</p>-->

                <div class="review_list" v-if="reviewsData && reviewsData.length">
                    <div class="review_card" v-for="(review, i) in reviewsData" :key="i">
                        <div class="review_avatar">{{review.name.charAt(0).toUpperCase()}}</div>
                        <p class="review_name">{{review.name}}</p>
                        <div class="review_stars">{{ '★'.repeat(review.rating) }}</div>
                        <p class="review_text">
                            {{review.description}}
                        </p>
                        <img class="review_google" :src="'/imgs/google.png'" alt="Google Icon">
                    </div>
                </div>
            </div>

        </div>
    </div>

  </div>
</template>

<script>
import '@/assets/js/chatButton.js'
</script>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
const props = defineProps(['apiUrl'])
const reviewsData = ref([]);
const apiUniqueNumber = Math.ceil(Math.random() * 1000000);
async function loadReviewData() {
  try {
    const response = await axios.get(`/API/getReviewsData.php?apiUnique=${apiUniqueNumber}&action=getCheckoutReviews`);
    reviewsData.value = response.data.data
  } catch (err) {
    console.error(err)
  }
}
onMounted(() => {
  loadReviewData();
})
</script>

<style>
        .review_container {
        width: 300px;
        margin: 0 auto 35px auto;
        text-align: center;
        font-family: Arial, sans-serif;
        }

        .review_title {
        font-size: 1.4rem;
        font-weight: bold;
        margin-bottom: 0px;
        }

        .review_stars {
        color: #fbbc05;
        font-size: 1.2rem;
        }
        .review_stars_row {
        display: flex;
        justify-content: center;
        gap: 2px;
        }

        .review_star {
        font-size: 1.2rem;
        position: relative;
        display: inline-block;
        color: #ccc; /* default gray star */
        }

        .review_star.full {
        color: #fbbc05;
        }

        .review_star.half::before {
        content: "★";
        color: #fbbc05;
        position: absolute;
        left: 0;
        width: 50%;
        overflow: hidden;
        }

        .review_rating {
        font-size: 0.95rem;
        color: #444;
        margin-bottom: 20px;
        }

        .review_list {
        max-height: 600px;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: #ccc transparent;
        padding-right: 5px;
        }

        .review_card {
        border: 1px solid #ddd;
        border-radius: 12px;
        padding: 15px;
        margin-bottom: 20px;
        background-color: #fff;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
        }

        .review_name {
        font-weight: bold;
        margin: 0;
        }

        .review_date {
        font-size: 0.85rem;
        color: #888;
        margin-bottom: 10px;
        }

        .review_text {
        font-size: 0.9rem;
        margin: 10px 0;
        color: #333;
        }

        .review_google {
        width: 24px;
        height: 24px;
        margin-top: 10px;
        }
        .review_avatar {
            width: 60px;
            height: 60px;
            background-color: #3c82b5;
            color: #fff;
            border-radius: 50%;
            font-size: 1.5rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 10px;
        }
    </style>